var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "4fa848e6a4947a571821a02a4506dbd98a9a6aab"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-js@when-i-work"] = {
  id: "4fa848e6a4947a571821a02a4506dbd98a9a6aab"
};